function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wiadomo\\u015Bci",
  transform: "translate(-304.000000, -621.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(273.000000, 574.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Messages/On",
  transform: "translate(30.000000, 44.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 21
}), /*#__PURE__*/React.createElement("g", {
  id: "wiadomosci",
  transform: "translate(1.000000, 3.150000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.2,10.8885 L14.2,10.0275 L15.46,9.261 L16,9.261 L16,12.2745 C16.1269055,12.179778 16.2045421,12.0283866 16.21,11.865 L16.21,1.365 C16.2191447,1.3094116 16.2191447,1.2525884 16.21,1.197 L16.21,1.197 C16.1547879,1.12796948 16.0819216,1.07696305 16,1.05 L15.95,1.05 C15.876747,0.995944593 15.7895318,0.966640284 15.7,0.966 L1,0.966 C0.910665497,0.967910977 0.823794844,0.997099516 0.75,1.05 L0.75,1.05 C0.681117974,1.10521271 0.626180562,1.17731806 0.589897815,1.26 L0.589897815,1.26 L0.589897815,11.76 L0.589897815,11.9385 C0.587312091,12.076764 0.637747886,12.2103428 0.729933657,12.3091133 C0.822119428,12.4078837 0.948292607,12.4635 1.08,12.4635 L15.07,12.4635 L15.07,10.353 L14.2,10.8885 Z",
  id: "Path",
  fill: "#48A9A1",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.56,0.818999995 L1,0.818999995 C0.828514543,0.818999995 0.664194032,0.891217347 0.543879106,1.01952194 C0.423564179,1.14782653 0.357320538,1.32146225 0.359921765,1.5015 L0.359921765,11.7075 C0.359921765,12.0803716 0.644926195,12.3842635 1,12.39 L10.87,12.39 C11.1461424,12.39 11.37,12.1549495 11.37,11.865 C11.37,11.5750505 11.1461424,11.34 10.87,11.34 L1.87,11.34 L6,6.951 L8,8.8515 C8.09443192,8.93771941 8.21487333,8.98607309 8.34,8.988 C8.46201074,8.98542159 8.57909634,8.93699073 8.67,8.8515 L10.67,6.951 L12,8.4 C12.0953883,8.50050572 12.2248664,8.55715241 12.36,8.5575 C12.4896962,8.55423627 12.6139384,8.50205453 12.71,8.4105 C12.9017833,8.20279564 12.9017833,7.87270436 12.71,7.665 L11.34,6.195 L15.2,2.541 L15.2,6.93 C15.2053201,7.21760388 15.4260915,7.44941389 15.7,7.455 C15.9761424,7.455 16.2,7.21994949 16.2,6.93 C16.2,6.93 16.2,3.0975 16.2,1.5015 C16.2,1.12862838 15.9150738,0.824736484 15.56,0.818999995 Z M1.39,10.395 L1.39,2.541 L5.24,6.237 L1.39,10.395 Z M8.3,7.749 L2.17,1.869 L14.42,1.869 L8.3,7.749 Z",
  id: "Shape",
  fill: "#555150"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.45,8.295 C14.1813157,8.295 13.038152,9.09924235 12.5554979,10.3311949 C12.0728439,11.5631474 12.346178,12.9791666 13.2475828,13.9165699 C14.1489875,14.8539732 15.500147,15.1273237 16.6687325,14.608696 C17.837318,14.0900683 18.5921599,12.8820574 18.58,11.55 C18.5635431,9.74722967 17.167003,8.29491719 15.45,8.295 L15.45,8.295 Z",
  id: "Shape",
  fill: "#48A9A1"
}))))));

var SvgUnreadNews = function SvgUnreadNews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnreadNews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/UnreadNews.2c66d1c0.svg";
export { ForwardRef as ReactComponent };